import React, { useState } from 'react';
import { Image } from 'antd';
import { Map, APILoader, Marker } from '@uiw/react-amap';
import './map_components.less'

export default function MapComponents (transfer) {
  const [show, setShow] = useState(true);
  const [map, setMap] = useState();
  // const data = [
  //     {
  //         longitude: 104.1881517321482,
  //         latitude: 30.836140077770256,
  //     },
  //     {
  //         longitude: 104.1881517321482,
  //         latitude: 30.736140077770256,
  //     },
  // ]

  return <APILoader akay="193db6af15a86cd8d48b102ab461b002">
    <div className='MapComponents'>
      <Map zoom={16} style={{ height: '100vh', width: '100vw' }}
        center={[transfer.longitude, transfer.latitude]}
        ref={(instance) => {
          if (instance && instance.map && !map) {
            setMap(instance.map);
          }
        }}>
        {/* 多个标记 */}
        {/* {
                    data.map((item,index) => {
                        return <Marker
                            visiable={show}
                            offset={[-13, -30]}
                            position={[item.longitude, item.latitude]}
                            key={index}
                        >
                            <div className='punctuation'>
                                <div className='Box'>
                                    <Image
                                        src={transfer.picUrl}
                                    />
                                </div>
                                <div className='triangle-down'></div>
                            </div>
                        </Marker>
                    })
                } */}
        {/* 单个标记 */}
        <Marker
          visiable={show}
          offset={[0, 0]}
          position={[transfer.longitude, transfer.latitude]}
        >

          <div style={{ position: 'relative' }}>
            <div className='punctuation' style={{ position: 'absolute', top: '-75px', left: '-42px' }}>
              <div className='Box'>
                <Image
                  src={transfer.picUrl}
                />
              </div>
              <div className='triangle-down'></div>
            </div>
          </div>

        </Marker>
        <div style={{ position: ' absolute', height: '100%', }}>
          <div style={{
            position: 'relative',
            left: '20px',
            bottom: "55px",
          }}
          >

            <div
              style={{ backgroundColor: 'rgba(0,0,0,0.4)', borderRadius: '4px' }}
            >
              <div style={{ color: '#FFF', padding: '4px 12px', fontSize: '14px', fontWeight: '500', }}>
                <span>{transfer.longitude}</span>
                <span>{` S / `}</span>
                <span>{transfer.latitude}</span>
                <span>{` N `}</span>
              </div>
            </div>


          </div>
        </div>
      </Map>
    </div>
  </APILoader>
}

